export const CBTPARTICIPANTS_GET = 'CBTPARTICIPANTS_GET';
export const CBTPARTICIPANT_EDIT = 'CBTPARTICIPANT_EDIT';
export const CBTPARTICIPANT_UPLOADFILE = 'CBTPARTICIPANT_UPLOADFILE';
export const CBTPARTICIPANT_DELETE = 'CBTPARTICIPANT_DELETE';
export const CBTPARTICIPANT_RESET_SEARCH = 'CBTPARTICIPANT_RESET_SEARCH';
